import { create } from 'zustand';

import type { AssistantEntityContext, ChatMessage } from './types';

/**
 * Ephemeral assistant-panel state (Wave 10). Client-only (F6):
 *   - `open`       — whether the drawer is visible
 *   - `entity`     — current route entity (Deal/Project/Employee) sent with each call
 *   - `messages`   — local chat history; BE has no per-user persistence
 *
 * Detail pages register their entity via `setEntity` in a `useEffect` and
 * clear it on unmount; the panel reads it for the entity-scoped retrieval.
 */
interface AssistantState {
  open: boolean;
  entity: AssistantEntityContext | null;
  messages: ChatMessage[];

  setOpen: (open: boolean) => void;
  toggle: () => void;
  setEntity: (entity: AssistantEntityContext | null) => void;
  appendMessage: (message: ChatMessage) => void;
  clearMessages: () => void;
}

export const useAssistant = create<AssistantState>((set) => ({
  open: false,
  entity: null,
  messages: [],

  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
  setEntity: (entity) => set({ entity }),
  appendMessage: (message) => set((s) => ({ messages: [...s.messages, message] })),
  clearMessages: () => set({ messages: [] }),
}));
